export enum LiveMatchKindType {
  COLABO = 'colabo',
  VS = 'vs',
}
export enum LiveMatchType {
  RANDOM = 'random',
  SPECIFIED = 'specified',
  ANY = 'any',
}

export enum LiveMatchStatusType {
  ACCEPT = 'accept',
  PENDING = 'pending',
  REJECT = 'reject',
  CANCEL = 'cancel',
}

export enum LiveMatchStartEnd {
  START = 'start',
  FINISH = 'finish',
}

export enum LiveMatchListMethod {
  FOR_ME = 'for-me',
  PLAYING = 'playing',
  PENDING = 'pending',
  HISTORY = 'history',
  THIS_MONTH = 'this-month',
  LAST_MONTH = 'last-month',
  TWO_MONTH_AGO = 'two-month-ago',
}
